import { useWatch } from 'react-hook-form';

import { SelectField } from '../SelectField/SelectField';
import { TextField } from '../TextField/TextField';

const OPTIONS = [
  { label: 'Day of collection', value: 'day_of_collection' },
  { label: 'Other', value: 'other' },
];

export const PriceAsIndexWhenToFixField = ({
  label,
  name,
  size,
  fullWidth = true,
}: {
  label: string;
  name: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}) => {
  const chosenOption = useWatch({ name: `${name}_options` });

  return (
    <>
      <SelectField label={label} options={OPTIONS} name={`${name}_options`} size={size} fullWidth={fullWidth} />
      {chosenOption === 'other' && (
        <TextField
          size="medium"
          name={`${name}_other_details`}
          label={label}
          type="text"
          slotProps={{
            htmlInput: {
              maxLength: 200,
            },
          }}
        />
      )}
    </>
  );
};
